import { LoaderButton } from 'components/molecules'
import { COMMERCE_PARTNER_NAMES } from 'domains/commerce-partner-product/constants'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button, Card } from 'reactstrap'

const propTypes = {
  commercePartnerProducts               : PropTypes.arrayOf(PropTypes.object),
  onClickGenerateCommercePartnerProduct : PropTypes.func,
  isGeneratingCommercePartnerProduct    : PropTypes.object
}

const defaultProps = {
  commercePartnerProducts               : [],
  onClickGenerateCommercePartnerProduct : () => {},
  isGeneratingCommercePartnerProduct    : {
    [COMMERCE_PARTNER_NAMES.ZALORA]: false
  }
}

/**
 * Commerce Partner Product detail view
 * Currently used in the product detail page
 * It'll take the assigned (or not assigned) products mapped from a particular TL product into
 * another e-commerce (such as Zalora), and encapsulate all of the assigned and map products.
 * If a products hasn't got their commerce partner product assigned to it, then this detail view
 * also stores a button function to generate the mapping to that particular e-commerce.
 * @param {array} commercePartnerProducts - all of the mapped commerce partner product for a particular product
 * @param {func} onClickGenerateCommercePartnerProduct - the function to call the commerce partner API, receiving the commerce partner name
 * @param {object} isGeneratingCommercePartnerProduct - object to store each of the commerce partner loading button boolean value, in the generate function, make sure to update this
 */
const CommercePartnerProductDetailView = ({
  commercePartnerProducts,
  onClickGenerateCommercePartnerProduct,
  isGeneratingCommercePartnerProduct
}) => {
  const [ zaloraProduct, setZaloraProduct ] = useState([])

  useEffect(() => {
    commercePartnerProducts.forEach((commerce_partner_product) => {
      if (commerce_partner_product?.commerce_partner?.name == COMMERCE_PARTNER_NAMES.ZALORA) setZaloraProduct(commerce_partner_product)
    })
  }, [ commercePartnerProducts ])

  const handleRedirectToZaloraSellerCenter = () => {
    window.open(
      `https://sellercenter.zalora.co.id/new/products/all-products?name_like=${zaloraProduct.model.sellerSku}`,
      '_blank'
    )
  }

  const isZaloraProductAvailable = zaloraProduct.length !== 0

  return (
    <>
      { /* Zalora product */ }
      <h3>{ 'Zalora Product' }</h3>
      {
        isZaloraProductAvailable ? (
          <Card body>
            <h3>{ `Product ${zaloraProduct?.model?.sellerSku}` }</h3>
            <div className='w-40'>
              <Button
                onClick={ handleRedirectToZaloraSellerCenter }
                color='info'
              >
                { 'Lihat Produk di Seller Center' }
              </Button>
            </div>
          </Card>
        ) : (
          <div>
            <p>
              { 'Katalog Zalora belum dibuat untuk produk ini' }
            </p>
            <LoaderButton
              color={ 'primary' }
              className='text-small rounded mb-3'
              onClick={ () => onClickGenerateCommercePartnerProduct(COMMERCE_PARTNER_NAMES.ZALORA) }
              isLoading={ isGeneratingCommercePartnerProduct[COMMERCE_PARTNER_NAMES.ZALORA] || false }
              text={ 'Buat Product Set Zalora' }
            />
          </div>
        )
      }
    </>
  )
}

CommercePartnerProductDetailView.propTypes    = propTypes
CommercePartnerProductDetailView.defaultProps = defaultProps

export default CommercePartnerProductDetailView